import { AssetVizHeatmapDisplayState } from '@asset-viz/defines'
import { createFileRoute } from '@tanstack/react-router'
import isNil from 'lodash/isNil'
import { Details } from 'pages/details/Details'
import { z } from 'zod'

import {
  SEARCH_PARAM_CDF,
  SEARCH_PARAM_COPC_DEBUG,
  SEARCH_PARAM_COPC_ID,
  SEARCH_PARAM_COPC_LOCAL_URL,
  SEARCH_PARAM_EXTENSION,
  SEARCH_PARAM_FORGING_VIEW_TYPE,
  SEARCH_PARAM_HEATMAP_DISPLAY_STATE,
  SEARCH_PARAM_INDICATION,
  SEARCH_PARAM_INSPECTION_ID,
  SEARCH_PARAM_MARKUP_LAYER_LABEL_VISIBILITY,
  SEARCH_PARAM_MARKUP_LAYERS,
  SEARCH_PARAM_MAX_FILTER,
  SEARCH_PARAM_MIN_FILTER,
  SEARCH_PARAM_POINT_CLOUD_ID,
  SEARCH_PARAM_SHOW_3D,
  SEARCH_PARAM_VISUAL_INSPECTION_ID,
} from './-searchParams'

export const detailsSearchSchema = z.object({
  [SEARCH_PARAM_CDF]: z.string().optional(),
  [SEARCH_PARAM_SHOW_3D]: z
    .preprocess((value) => {
      if (isNil(value)) return true // Default to true if not provided
      return value
    }, z.boolean().optional())
    .optional(),
  [SEARCH_PARAM_MIN_FILTER]: z
    .preprocess(
      (value) => {
        if (typeof value === 'string') {
          if (value === 'Infinity') return Infinity
          if (value === '-Infinity') return -Infinity
          const parsed = parseFloat(value)
          if (isNaN(parsed)) return undefined
          return parsed
        }
        return value // Pass through if already a number
      },
      z
        .number()
        .or(z.literal(Number.POSITIVE_INFINITY))
        .or(z.literal(Number.NEGATIVE_INFINITY))
        .optional() // Final schema expects a number
    )
    .optional(),
  [SEARCH_PARAM_MAX_FILTER]: z
    .preprocess(
      (value) => {
        if (typeof value === 'string') {
          if (value === 'Infinity') return Infinity
          if (value === '-Infinity') return -Infinity
          const parsed = parseFloat(value)
          if (isNaN(parsed)) return undefined
          return parsed
        }
        return value // Pass through if already a number
      },
      z
        .number()
        .or(z.literal(Number.POSITIVE_INFINITY))
        .or(z.literal(Number.NEGATIVE_INFINITY))
        .optional() // // Final schema expects a number
    )
    .optional(),
  [SEARCH_PARAM_MARKUP_LAYERS]: z.string().optional(),
  [SEARCH_PARAM_EXTENSION]: z.string().optional(),
  [SEARCH_PARAM_INDICATION]: z.string().optional(),
  [SEARCH_PARAM_HEATMAP_DISPLAY_STATE]: z
    .enum(AssetVizHeatmapDisplayState)
    .optional(),
  [SEARCH_PARAM_INSPECTION_ID]: z.string().optional(),
  [SEARCH_PARAM_VISUAL_INSPECTION_ID]: z.string().optional(),
  [SEARCH_PARAM_MARKUP_LAYER_LABEL_VISIBILITY]: z
    .preprocess((value) => {
      if (typeof value === 'string') {
        return value.split(',').filter(Boolean)
      }
      return value
    }, z.array(z.string()))
    .optional(),
  [SEARCH_PARAM_POINT_CLOUD_ID]: z.string().optional(),
  [SEARCH_PARAM_FORGING_VIEW_TYPE]: z.string().optional(),
  [SEARCH_PARAM_COPC_LOCAL_URL]: z.string().optional(),
  [SEARCH_PARAM_COPC_ID]: z.string().optional(),
  [SEARCH_PARAM_COPC_DEBUG]: z
    .preprocess(
      (value) => (value === 1 ? '1' : value),
      z.literal('1').optional()
    )
    .optional(),
})

export const Route = createFileRoute('/details/$entryID')({
  component: Details,
  staticData: {
    layout: {
      defaultClosedNav: true,
      enforceMaxWidth: false,
    },
  },
  validateSearch: detailsSearchSchema,
})
